module.exports = __webpack_public_path__ + "static/media/39.75940510.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/39.jpg
// module id = 729
// module chunks = 0